<template>
  <div class="layout-container dark-theme">
    <a-layout id="components-layout-demo-custom-trigger">
      <a-layout-sider v-model="collapsed" :trigger="null" collapsible width="256" class="custom-sider">
        <div class="logo-wrapper" @click="$router.push('/')">
          <img src="/logo.png" alt="logo" class="brand-logo-img" />
          <span class="brand-text" v-if="!collapsed">spaceproxy</span>
        </div>
        <a-menu 
          theme="dark" 
          mode="inline" 
          :selected-keys="selectedKeys" 
          :open-keys="openKeys" 
          @openChange="onOpenChange" 
          @click="handleMenuClick"
          class="custom-menu"
        >
          <a-sub-menu key="sub1">
            <span slot="title"><a-icon type="safety-certificate" /><span>{{ $t('menu.auth') }}</span></span>
            <a-menu-item key="2">
              {{ $t('menu.auth') }}
            </a-menu-item>
            <!-- <a-menu-item key="3">
              {{ $t('menu.subaccount') }}
            </a-menu-item> -->
            <a-menu-item key="4">
              {{ $t('menu.trafficRecord') }}
            </a-menu-item>
          </a-sub-menu>
          <!-- <a-sub-menu key="sub5">
            <span slot="title"><a-icon type="cloud-server" /><span>{{ $t('menu.staticProxy') }}</span></span>
            <a-menu-item key="9">
              {{ $t('menu.staticList') }}
            </a-menu-item>
            <a-menu-item key="10">
              {{ $t('menu.staticPurchase') }}
            </a-menu-item>
            <a-menu-item key="11">
              {{ $t('menu.broadcastPurchase') }}
            </a-menu-item>
          </a-sub-menu> -->
          <a-sub-menu key="sub3">
            <span slot="title"><a-icon type="file-text" /><span>{{ $t('menu.recordQuery') }}</span></span>
            <a-menu-item key="6">
              {{ $t('menu.flowChangeRecord') }}
            </a-menu-item>
            <a-menu-item key="7">
              {{ $t('menu.loginRecord') }}
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub4">
            <span slot="title"><a-icon type="tool" /><span>{{ $t('menu.proxyCheck') }}</span></span>
            <a-menu-item key="8">
              {{ $t('menu.proxyCheck') }}
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub2">
            <span slot="title"><a-icon type="user" /><span>{{ $t('menu.personalCenter') }}</span></span>
            <a-menu-item key="5">
              {{ $t('menu.personalSettings') }}
            </a-menu-item>
            <a-menu-item key="logout">
              {{ $t('menu.logout') }}
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </a-layout-sider>
      <a-layout class="main-layout">
        <a-layout-header class="custom-header">
          <div class="header-content">
            <button class="trigger-btn" @click="() => (collapsed = !collapsed)">
              <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
            </button>
            <div class="header-right">
              <a-dropdown :trigger="['click']" placement="bottomCenter">
                <button class="action-icon-btn lang-btn">
                  <a-icon type="global" />
                  <span class="lang-text">{{ $i18n.locale === 'zh-CN' ? '中' : 'EN' }}</span>
                </button>
                <a-menu slot="overlay" @click="handleLangClick" class="custom-dark-menu">
                  <a-menu-item key="zh-CN">🇨🇳 简体中文</a-menu-item>
                  <a-menu-item key="en-US">🇺🇸 English</a-menu-item>
                </a-menu>
              </a-dropdown>
              
              <a-dropdown :trigger="['hover']" placement="bottomRight">
                <button class="user-pill">
                  <div class="u-avatar"><a-icon type="user" /></div>
                  <span class="u-name">{{ username }}</span>
                  <a-icon type="down" class="dropdown-icon" />
                </button>
                <a-menu slot="overlay" class="custom-dark-menu">
                  <a-menu-item key="profile" @click="handleProfileClick">
                    <a-icon type="user" />{{ $t('menu.personalCenter') }}
                  </a-menu-item>
                  <a-menu-divider />
                  <a-menu-item key="logout" @click="handleLogout" class="danger-text">
                    <a-icon type="logout" />{{ $t('menu.logout') }}
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </div>
        </a-layout-header>
        <a-layout-content class="custom-content">
          <transition name="fade-transform" mode="out-in">
            <router-view />
          </transition>
        </a-layout-content>
      </a-layout>
    </a-layout>

    <!-- 悬浮客服按钮 -->
    <div id="kefu" class="kefu-float">
      <button class="c-btn" @click="Kefu()" :title="$t('menu.customerService')">
        <a-icon type="customer-service" />
      </button>
    </div>
    
    <!-- 客服弹窗 -->
    <a-modal
        v-model="visible"
        :title="$t('menu.customerService')"
        :footer="null"
        width="500px"
        :maskClosable="true"
        class="dark-modal"
      >
      <div class="kefu-modal-content">
        <div class="kefu-item" v-for="item in FormatList" :key="item.id">
          <div class="k-info">
            <span class="k-type">{{ item.contacttype }} :</span> 
            <a :href='item.link' class="k-link">{{ item.contact }}</a>
          </div>
          <div class="k-qrcode" v-if="item.contacttype == 'wechat' || item.contacttype == 'qq'">
            <qrcode-vue :value="item.contact" :size="150" level="L" />
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode-vue';

export default {
  name: 'BasicLayout',
  components: {
    QrcodeVue
  },
  data() {
    return {
      collapsed: false,
      username: localStorage.getItem('userName') || 'User',
      openKeys: ['sub1'], // 默认只展开当前路由对应的菜单
      rootSubmenuKeys: ['sub1', 'sub2', 'sub3', 'sub4', 'sub5'],
      selectedKeys: ['2'],
      // 客服相关
      visible: false,
      FormatList: [],
    };
  },
  watch: {
    $route: {
      handler: function() {
        this.updateMenu();
      },
      immediate: true
    }
  },
  created() {
    this.updateMenu();
  },
  methods: {
    updateMenu() {
      const path = this.$route.path;
      if (path === '/dashboard/auth') {
        this.selectedKeys = ['2'];
        this.openKeys = ['sub1'];
      } else if (path === '/dashboard/traffic') {
        this.selectedKeys = ['4'];
        this.openKeys = ['sub1'];
      } else if (path === '/record/flow-change') {
        this.selectedKeys = ['6'];
        this.openKeys = ['sub3'];
      } else if (path === '/record/login') {
        this.selectedKeys = ['7'];
        this.openKeys = ['sub3'];
      } else if (path === '/check/proxy') {
        this.selectedKeys = ['8'];
        this.openKeys = ['sub4'];
      } else if (path === '/static/list') {
        this.selectedKeys = ['9'];
        this.openKeys = ['sub5'];
      } else if (path === '/static/purchase') {
        this.selectedKeys = ['10'];
        this.openKeys = ['sub5'];
      } else if (path === '/static/broadcast-purchase') {
        this.selectedKeys = ['11'];
        this.openKeys = ['sub5'];
      } else if (path === '/user/profile') {
        this.selectedKeys = ['5'];
        this.openKeys = ['sub2'];
      }
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    handleProfileClick() {
      if (this.$route.path !== '/user/profile') {
        this.$router.push('/user/profile');
      }
    },
    handleMenuClick({ key }) {
      if (key === '2') {
        if (this.$route.path !== '/dashboard/auth') {
          this.$router.push('/dashboard/auth');
        }
      } 
      // else if (key === '3') {
      //   if (this.$route.path !== '/dashboard/subaccount') {
      //     this.$router.push('/dashboard/subaccount');
      //   }
      // } 
      else if (key === '4') {
        if (this.$route.path !== '/dashboard/traffic') {
          this.$router.push('/dashboard/traffic');
        }
      } else if (key === '6') {
        if (this.$route.path !== '/record/flow-change') {
          this.$router.push('/record/flow-change');
        }
      } else if (key === '7') {
        if (this.$route.path !== '/record/login') {
          this.$router.push('/record/login');
        }
      } else if (key === '8') {
        if (this.$route.path !== '/check/proxy') {
          this.$router.push('/check/proxy');
        }
      } else if (key === '9') {
        if (this.$route.path !== '/static/list') {
          this.$router.push('/static/list');
        }
      } else if (key === '10') {
        if (this.$route.path !== '/static/purchase') {
          this.$router.push('/static/purchase');
        }
      } else if (key === '11') {
        if (this.$route.path !== '/static/broadcast-purchase') {
          this.$router.push('/static/broadcast-purchase');
        }
      } else if (key === '5') {
        if (this.$route.path !== '/user/profile') {
          this.$router.push('/user/profile');
        }
      } else if (key === 'logout') {
        this.handleLogout();
      }
    },
    handleLangClick({ key }) {
      this.$i18n.locale = key;
      localStorage.setItem('language', key);
    },
    handleLogout() {
      localStorage.clear();
      this.$message.success(this.$t('header.logoutSuccess'));
      this.$router.push('/login');
    },
    // 获取客服联系方式
    getCommentsDataList() {
      // 更新userId，确保获取最新的用户ID
      this.userId = localStorage.getItem('userId') || '';
      this.$request.get("/contact/selectAgentContact?userId=" + this.userId).then((res) => {
        if (res.data.code === 200) {
          this.FormatList = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    
    // 打开客服弹窗
    Kefu() {
      this.getCommentsDataList();
      this.visible = true;
    }
  },
};
</script>

<style scoped lang="less">
/* Variables */
@bg-dark: #09090b;
@card-bg: #18181b;
@border: #27272a;
@primary: #8b5cf6;
@primary-hover: #a855f7;
@accent: #3b82f6;
@text-main: #f4f4f5;
@text-muted: #a1a1aa;

.layout-container {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  background-color: @bg-dark;
  color: @text-main;
  min-height: 100vh;
}

#components-layout-demo-custom-trigger {
  height: 100vh;
  background: transparent;
}

button {
  outline: none;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
}

/* 侧边栏整体样式 */
.custom-sider {
  background: @card-bg !important;
  border-right: 1px solid @border;
  z-index: 10;
}

/* Logo 样式 */
.logo-wrapper {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  border-bottom: 1px solid @border;
  transition: all 0.3s;
  
  &:hover { background: rgba(255,255,255,0.02); }
}

.brand-logo-img {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  object-fit: cover;
}

.brand-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, @primary, @accent);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  svg { width: 20px; height: 20px; }
}

.brand-text {
  color: #fff;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.5px;
}

/* 菜单样式重写 */
.custom-menu {
  background: transparent !important;
  border-right: none !important;
  padding-top: 16px;
}

/* 覆盖 Ant Design 菜单样式 */
:deep(.ant-menu-item), :deep(.ant-menu-submenu-title) {
  height: 48px !important;
  line-height: 48px !important;
  margin: 4px 12px !important;
  width: calc(100% - 24px) !important;
  border-radius: 12px;
  color: @text-muted !important;
  font-size: 15px;
  transition: all 0.3s;
}

:deep(.ant-menu-submenu-title:hover), :deep(.ant-menu-item:hover) {
  color: #fff !important;
  background-color: rgba(255,255,255,0.05) !important;
}

/* 选中项样式 */
:deep(.ant-menu-item-selected) {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.2), rgba(59, 130, 246, 0.2)) !important;
  color: @primary !important;
  border: 1px solid rgba(139, 92, 246, 0.3);
}

:deep(.ant-menu-item-selected:after) {
  display: none;
}

/* 子菜单选中时父级样式 */
:deep(.ant-menu-submenu-selected .ant-menu-submenu-title) {
  color: #fff !important;
}

:deep(.ant-menu-sub) {
  background: transparent !important;
  box-shadow: none !important;
}

/* 图标样式 */
:deep(.ant-menu-item .anticon), :deep(.ant-menu-submenu-title .anticon) {
  font-size: 18px;
  margin-right: 12px;
  transition: color 0.3s;
}

/* 收起时的图标居中 */
.ant-layout-sider-collapsed :deep(.ant-menu-item .anticon), 
.ant-layout-sider-collapsed :deep(.ant-menu-submenu-title .anticon) {
  margin-right: 0;
  font-size: 20px;
}

/* 顶部 Header */
.main-layout {
  background: @bg-dark !important;
}

.custom-header {
  background: @card-bg !important;
  padding: 0 !important;
  border-bottom: 1px solid @border;
  height: 64px;
  line-height: 64px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 24px;
}

.trigger-btn {
  font-size: 20px;
  color: @text-muted;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.3s;
  
  &:hover {
    background: rgba(255,255,255,0.05);
    color: #fff;
  }
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.action-icon-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  color: @text-muted;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.3s;
  border: none;
  background: transparent;
  
  &:hover {
    color: #fff;
  }
}

.user-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  padding: 4px 12px 4px 4px;
  border-radius: 20px;
  color: @text-main;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s;
  
  .u-avatar {
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, @primary, @accent);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #fff;
  }
  
  .dropdown-icon {
    font-size: 12px;
    color: @text-muted;
    margin-left: 4px;
  }
}

/* 黑暗下拉菜单 */
:deep(.custom-dark-menu) {
  background: @card-bg;
  border: 1px solid @border;
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5);
  
  .ant-dropdown-menu-item {
    color: @text-muted;
    border-radius: 6px;
    padding: 8px 16px;
    margin-bottom: 4px;
    transition: all 0.2s;
    
    &:hover {
      background: rgba(255,255,255,0.05);
      color: #fff;
    }
    
    &.danger-text {
      color: #ef4444;
      &:hover {
        background: rgba(239, 68, 68, 0.1);
      }
    }
  }
  
  .ant-dropdown-menu-item-divider {
    background-color: @border;
    margin: 8px 0;
  }
}

/* 内容区域 */
.custom-content {
  margin: 0;
  padding: 24px;
  background: @bg-dark;
  min-height: calc(100vh - 64px);
  overflow-y: auto;
}

/* 客服悬浮按钮 */
.kefu-float {
  position: fixed; 
  bottom: 40px; 
  right: 40px; 
  z-index: 999;
  
  .c-btn {
    width: 60px; height: 60px;
    background: linear-gradient(135deg, @primary, @accent);
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    color: #fff; font-size: 28px;
    box-shadow: 0 10px 25px rgba(139, 92, 246, 0.4);
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    
    &:hover {
      transform: scale(1.1) translateY(-5px);
      box-shadow: 0 15px 35px rgba(139, 92, 246, 0.5);
    }
  }
}

/* 客服弹窗 */
:deep(.dark-modal) {
  .ant-modal-content {
    background: @card-bg;
    border: 1px solid @border;
    border-radius: 16px;
    box-shadow: 0 20px 50px rgba(0,0,0,0.6);
  }
  
  .ant-modal-header {
    background: transparent;
    border-bottom: 1px solid @border;
    border-radius: 16px 16px 0 0;
  }
  
  .ant-modal-title {
    color: #fff;
    font-weight: 700;
    font-size: 18px;
  }
  
  .ant-modal-close {
    color: @text-muted;
    &:hover { color: #fff; }
  }
}

.kefu-modal-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.kefu-item {
  background: rgba(255,255,255,0.02);
  border: 1px solid @border;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  
  .k-info {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    
    .k-type { color: @text-muted; }
    .k-link { 
      color: @primary; 
      font-weight: 600;
      &:hover { text-decoration: underline; }
    }
  }
  
  .k-qrcode {
    background: #fff;
    padding: 10px;
    border-radius: 8px;
  }
}

/* 页面切换动画 */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

.fade-transform-enter {
  opacity: 0;
  transform: translateY(20px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>